module.exports = __webpack_public_path__ + "img/logo-white.ca01947e.png";